import { render, staticRenderFns } from "./CVLaborTable.vue?vue&type=template&id=7a8f37f8&"
import script from "./CVLaborTable.vue?vue&type=script&lang=js&"
export * from "./CVLaborTable.vue?vue&type=script&lang=js&"
import style0 from "./CVLaborTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSelect,VSimpleTable})
